import {createAction} from "redux-act";
import {IFetchVotesResponse, ISaveVotesResponse} from "modules/types";

export const fetchFanVotes = createAction<boolean>();
export const fetchFanVotesSuccess = createAction<IFetchVotesResponse>();
export const fetchFanVotesFailed = createAction();

export const addFanVotePlayer = createAction<number>();
export const removeFanVotePlayer = createAction();

export const saveFanVotePlayer = createAction();
export const saveFanVotePlayerSuccess = createAction<ISaveVotesResponse>();
export const saveFanVotePlayerFailed = createAction();

export const setFanVoteHasChanged = createAction();
